import React from 'react';
import { motion } from 'framer-motion';
type PanelProps = {
  image: string;
  alt: string;
  keyword: string;
  title: string;
  reverse?: boolean;
};
function ImagePanel({
  image,
  alt,
  keyword,
  title,
  reverse
}: PanelProps) {
  return <div className={`grid grid-cols-1 md:grid-cols-2 ${reverse ? 'md:[direction:rtl]' : ''}`} data-id="element-118">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }} className="relative aspect-[4/3] md:aspect-auto md:min-h-[60vh] overflow-hidden border-b md:border-b-0 md:border-r border-gridline [direction:ltr]" data-id="element-119">
        <img src={image} alt={alt} className="absolute inset-0 h-full w-full object-cover" data-id="element-120" />
        <div className="absolute inset-0 bg-black/40" aria-hidden="true" data-id="element-121" />
        <span className="absolute bottom-6 left-6 md:bottom-10 md:left-10 text-accent font-black uppercase tracking-tight text-3xl md:text-5xl" data-id="element-122">
          {keyword}
        </span>
      </motion.div>
      <div className="flex flex-col justify-center px-8 py-14 md:px-16 [direction:ltr]" data-id="element-123">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="text-white font-black uppercase leading-none tracking-tight text-4xl md:text-6xl" data-id="element-124">
          {title}
        </motion.h2>
        <p className="mt-6 max-w-md text-white/60 text-sm md:text-base leading-relaxed" data-id="element-125">
          {keyword === 'Sips' ? 'Precision-crafted cocktails and curated spirits programs. Every pour is a study in balance, theatre, and taste.' : 'Chef-driven small plates engineered to pair. Bold, tactile, and unforgettable bites built for the moment.'}
        </p>
      </div>
    </div>;
}
export function GridPanels() {
  return <section id="lookbook" className="w-full max-w-[95%] lg:max-w-[85%] mx-auto border-x border-b border-gridline my-10 md:my-20" data-id="element-126">
      <ImagePanel image="https://images.unsplash.com/photo-1551024601-bec78aea704b?auto=format&fit=crop&w=1600&q=80" alt="Bartender crafting a signature cocktail in low light" keyword="Sips" title="Mixology & Sips" data-id="element-127" />

      <div className="border-t border-gridline" data-id="element-128">
        <ImagePanel image="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=1600&q=80" alt="Elegant plated small bites on a dark table setting" keyword="Nibbles" title="Culinary & Nibbles" reverse data-id="element-129" />
      </div>

      <div className="relative border-t border-gridline overflow-hidden" data-id="element-130">
        <img src="https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=2000&q=80" alt="Sophisticated private event venue at night" className="absolute inset-0 h-full w-full object-cover" data-id="element-131" />
        <div className="absolute inset-0 bg-black/70" aria-hidden="true" data-id="element-132" />
        <div className="relative z-10 px-8 py-24 md:py-40 text-center" data-id="element-133">
          <motion.h2 initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7
        }} className="text-white font-black uppercase leading-none tracking-tight text-4xl sm:text-6xl md:text-8xl" data-id="element-134">
            Bespoke Events
          </motion.h2>
          <p className="mt-6 mx-auto max-w-xl text-white/60 text-sm md:text-base leading-relaxed" data-id="element-135">
            Fully produced experiences tailored to the room. From intimate
            tastings to large-scale activations, designed end to end.
          </p>
        </div>
      </div>
    </section>;
}